import React from "react";
import Lessons from "../../components/RoleBased/Lessons";
import { connect } from "react-redux";
import { getIsLessonLoading, fetchLessonsForGroup, getLessons, clearLessons, removeLessonById } from "../../reducers/lesson";
import { getCurrentUser } from "../../reducers/login";
import { bindActionCreators } from "redux";

const LessonsContainer = props => <Lessons {...props} />;

const mapState = (state, props) => ({
    currentUser: getCurrentUser(state),
    group: props.match.params.group,
    plan: getLessons(state),
    isLoading: getIsLessonLoading(state), 
});

const actions = (dispatch, props) => ({
    fetchLessonsForGroup: bindActionCreators(fetchLessonsForGroup, dispatch),
    removeLessonById: bindActionCreators(removeLessonById, dispatch),
    clearLessons: bindActionCreators(clearLessons, dispatch),
});

export default connect(mapState, actions)(LessonsContainer);